var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 10.0833H17.6654M8.91536 10.0833L9.4987 17.0833C9.4987 17.3928 9.62161 17.6895 9.84041 17.9083C10.0592 18.1271 10.3559 18.25 10.6654 18.25H15.332C15.6415 18.25 15.9382 18.1271 16.157 17.9083C16.3758 17.6895 16.4987 17.3928 16.4987 17.0833L17.082 10.0833M11.2487 10.0833V8.33333C11.2487 8.17862 11.3102 8.03025 11.4196 7.92085C11.5289 7.81146 11.6773 7.75 11.832 7.75H14.1654C14.3201 7.75 14.4684 7.81146 14.5778 7.92085C14.6872 8.03025 14.7487 8.17862 14.7487 8.33333V10.0833M11.832 13L14.1654 15.3333M14.1654 13L11.832 15.3333",
    stroke: "#F55843",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/delete-button.d5b062270d3a7a56d096eb029fdad406.svg";
export { ForwardRef as ReactComponent };